import React, { useContext } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { useParams } from 'react-router-dom'
import { selectCrossClientResultExecutionLoading, selectCrossClientResultsExecution } from '../../../store/crossClient/crossClientResults'
import { CrossClientResultsActions } from '../Actions/CrossClientResultsActions'
import { CrmActionHostProvider } from '../Actions/CrmActionHostProvider'
import { CrossClientResultsInitialization } from './CrossClientResultsInitialization'
import { CrossClientResultsPoller } from './CrossClientResultsPoller'
import { CrossClientActionsPoller } from '../Actions/CrossClientActionsPoller'
import { CrossClientQueryPhase, CrossClientQueryPhases } from '../../../models/CrossClient'
import { CrossClientTable } from '../Table/CrossClientTable'
import { CrossClientSidebar } from './Sidebar/CrossClientSidebar'
import { CrossClientMatchFilter } from './Filter/CrossClientMatchFilter'
import { CrossClientNameFilter } from './Filter/CrossClientNameFilter'
import { createPortal } from 'react-dom'
import { CrossClientHeader } from './Header/CrossClientHeader'
import { CrossClientResultsHeader } from './Header/CrossClientResultsHeader'
import { HeaderContext } from '../../LayoutWithLeftSidebar/HeaderContext'
import { Spinner } from '../../../components/Spinner/Spinner'
import { CrossClientQueryNotOwned } from '../NotOwned/CrossClientQueryNotOwned'
import './CrossClientResults.scss'

export const CrossClientResults = () => {
  const { executionId } = useParams()

  if (!executionId) {
    return <div>No query provided</div>
  }

  return (
    <>
      <CrossClientResultsInitialization executionId={executionId} />
      <CrossClientResultsPoller executionId={executionId} />
      <CrossClientActionsPoller executionId={executionId} />
      <CrossClientResultsBody executionId={executionId} />
    </>
  )
}

interface CrossClientResultsBodyProps {
  executionId: string
}

const EVALUATION_PHASES: CrossClientQueryPhase[] = [
  CrossClientQueryPhases.READY,
  CrossClientQueryPhases.QUEUED,
  CrossClientQueryPhases.PROCESSING,
  CrossClientQueryPhases.COMPLETED,
  CrossClientQueryPhases.CANCELED,
  CrossClientQueryPhases.ERRORED,
]

const CrossClientResultsBody: React.FC<CrossClientResultsBodyProps> = () => {
  const { portalRef } = useContext(HeaderContext)

  const execution = useAppSelector(selectCrossClientResultsExecution)
  const executionLoading = useAppSelector(selectCrossClientResultExecutionLoading)

  if (executionLoading) {
    return (
      <div className='d-flex flex-column align-items-center justify-content-center gap-3 mt-10'>
        <Spinner />
        <div className='paragraph-medium medium'>Pulling up your results…</div>
      </div>
    )
  }

  if (!execution) {
    return <CrossClientQueryNotOwned />
  }

  if (!EVALUATION_PHASES.includes(execution.phase)) {
    return <div>Query is not in evaluation phase</div>
  }

  return (
    <CrmActionHostProvider>
      <div className='truly-full-size-content d-flex cross-client-results-container'>
        {portalRef && portalRef.current ? createPortal(<CrossClientHeader />, portalRef.current) : null}
        <div className='d-flex flex-column cross-client-results-left zocks-p-2.0 gap-4'>
          <div className='d-flex align-items-start justify-content-between gap-3'>
            <CrossClientResultsHeader execution={execution} />
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <div className='d-flex gap-2'>
              <CrossClientMatchFilter />
              <CrossClientNameFilter />
            </div>
            <CrossClientResultsActions />
          </div>
          <CrossClientTable />
        </div>
        <div className='cross-client-results-right'>
          <CrossClientSidebar />
        </div>
      </div>
    </CrmActionHostProvider>
  )
}
